
import {
    captionTitle,
    cellInner,
    copyButtonWrapper,
    surveySummaryTableStyles,
} from 'components/AudienceMetadata/styles/SurveySummaryTable'

export const styledHtaConnectorView = surveySummaryTableStyles

export {
    captionTitle,
    cellInner,
    copyButtonWrapper,
}

